<template>
    <div id="page-text-fields">
        <v-container grid-list-xl fluid>
            <v-form @submit.prevent="handleSubmit">
                <v-layout row wrap>
                    <v-flex sm12>
                        <v-widget title="اطلاعات کاربری">
                            <div slot="widget-content">
                                <v-container>
                                    <v-layout>
                                        <v-flex v-if="user_data.person_type === 'Individual'">
                                            <v-autocomplete
                                                    label="جنسیت"
                                                    :items="sexes"
                                                    v-model="user_data.sex"
                                                    autocomplete
                                                    menu-props="auto"
                                                    required
                                                    item-text="name"
                                                    item-value="id"
                                            ></v-autocomplete>
                                        </v-flex>
                                        <v-flex v-if="user_data.person_type === 'Individual'">
                                            <v-text-field
                                                    label="نام"
                                                    name="name"
                                                    v-model="user_data.name"
                                                    type="text"

                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex>
                                            <v-text-field
                                                    :label="user_data.person_type === 'Individual'?'نام خانوادگی':'نام شرکت'"
                                                    name="family"
                                                    v-model="user_data.family"
                                                    type="text"

                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex>
                                            <v-text-field
                                                    label="نام نمایشی"
                                                    name="showing_name"
                                                    v-model="user_data.showing_name"
                                                    type="text"

                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>

                                        <v-flex>
                                            <v-text-field
                                                    label="کدملی"
                                                    name="national"
                                                    v-model="user_data.national"
                                                    type="text"
                                                    data-ltr
                                                    :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex>
                                            <v-autocomplete
                                                    label="استان"
                                                    :items="provinces"
                                                    v-model="province_id"
                                                    autocomplete
                                                    menu-props="auto"
                                                    required
                                                    item-text="name"
                                                    item-value="id"
                                            ></v-autocomplete>
                                        </v-flex>
                                        <v-flex>
                                            <v-autocomplete
                                                    label="شهر"
                                                    :items="getCities"
                                                    v-model="user_data.city"
                                                    autocomplete
                                                    menu-props="auto"
                                                    required
                                                    item-text="name"
                                                    item-value="id"
                                            ></v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>

                                        <v-flex>
                                            <v-text-field
                                                    label="ایمیل"
                                                    name="email"
                                                    v-model="user_data.email"
                                                    type="text"
                                                    data-ltr
                                                    maxlength="72"
                                                    :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex>
                                            <v-text-field
                                                    label="تلفن ثابت"
                                                    data-ltr
                                                    maxlength="11"
                                                    name="phone"
                                                    v-model="user_data.phone"
                                                    type="text"
                                                    :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex>
                                            <v-text-field
                                                    label="موبایل"
                                                    name="mobile"
                                                    v-model="user_data.mobile"
                                                    type="text"
                                                    data-ltr

                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>

                                        <v-flex xs8 lg8>
                                            <v-text-field
                                                    label="آدرس"
                                                    name="address"
                                                    maxlength="255"
                                                    v-model="user_data.address"
                                                    type="text"

                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs4 lg4>
                                            <v-text-field
                                                    label="کد پستی"
                                                    data-ltr
                                                    maxlength="10"
                                                    name="postal_code"
                                                    v-model="user_data.postal_code"
                                                    type="text"

                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>

                                        <v-flex>
                                            <v-autocomplete
                                                    label="نوع شخص"
                                                    :items="person_types"
                                                    v-model="user_data.person_type"
                                                    autocomplete
                                                    menu-props="auto"
                                                    required
                                                    item-text="name"
                                                    item-value="id"
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex v-if="user_data.debt_limit > 0">
                                            <v-text-field
                                                    label="حد مجاز بدهکاری(ریال)"
                                                    name="debt_limit"
                                                    v-model="user_data.debt_limit"
                                                    data-number
                                                    disabled
                                                    type="text"
                                                    :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout v-if="user_data.person_type === 'Legal'">
                                        <v-flex>
                                            <v-text-field
                                                    label="نام رابط"
                                                    name="connector_name"
                                                    v-model="user_data.connector_name"
                                                    type="text"
                                                    maxlength="72"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex>
                                            <v-text-field
                                                    label="سمت رابط"
                                                    maxlength="72"
                                                    name="connector_post"
                                                    v-model="user_data.connector_post"
                                                    type="text"

                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field
                                                    label="مرجع فروش(آدرس وبسایت)"
                                                    name="sales_reference"
                                                    data-ltr
                                                    maxlength="255"
                                                    v-model="user_data.sales_reference"
                                                    type="text"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex>
                                            <v-text-field
                                                    label="شماره شبای بانکی"
                                                    name="shaba"
                                                    data-ltr
                                                    maxlength="26"
                                                    v-model="user_data.shaba"
                                                    type="text"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-btn
                                                :loading="loading"
                                                :disabled="loading"
                                                color="green"
                                                class="white--text"
                                                large
                                                type="submit"
                                        >
                                            ذخیره
                                            &nbsp;
                                            <v-icon left dark>save</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </v-container>
                            </div>
                        </v-widget>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-container>

        <v-container grid-list-xl fluid>
            <v-form @submit.prevent="handleSubmitExtra">
                <v-layout row wrap>
                    <v-flex sm12>
                        <v-widget title="مشخصات نمایشی طراح (جهت نمایش در پروفایل بازارچه)">
                            <div slot="widget-content">
                                <v-container>

                                    <v-layout>
                                        <v-flex xs12>
                                            <v-text-field
                                                    label="نام کاربری توییتر"
                                                    name="twitter"
                                                    v-model="extras.twitter"
                                                    type="text"
                                                    @change="extras.twitter = extras.twitter.replace('https://twitter.com/','')"
                                                    maxlength="72"
                                                    data-ltr
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                    label="نام کاربری اینستاگرام"
                                                    name="instagram"
                                                    v-model="extras.instagram"
                                                    type="text"
                                                    @change="extras.instagram = extras.instagram.replace('https://instagram.com/','')"
                                                    maxlength="72"
                                                    data-ltr
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs12>
                                            <v-text-field
                                                    label="نام کاربری فیسبوک"
                                                    name="facebook"
                                                    v-model="extras.facebook"
                                                    type="text"
                                                    @change="extras.facebook = extras.facebook.replace('https://facebook.com/','')"
                                                    maxlength="72"
                                                    data-ltr
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                    label="نام کاربری دریبل"
                                                    name="dribbble"
                                                    v-model="extras.dribbble"
                                                    type="text"
                                                    @change="extras.dribbble = extras.dribbble.replace('https://dribbble.com/','')"
                                                    maxlength="72"
                                                    data-ltr
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs12>
                                            <v-text-field
                                                    label="آدرس یوتیوب"
                                                    name="youtube"
                                                    v-model="extras.youtube"
                                                    type="text"
                                                    @change="extras.youtube = extras.youtube.replace('https://youtube.com/','')"
                                                    maxlength="72"
                                                    data-ltr
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                    label="آدرس تلگرام"
                                                    name="telegram"
                                                    v-model="extras.telegram"
                                                    @change="fixTelegram"
                                                    type="text"
                                                    maxlength="72"
                                                    data-ltr
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-textarea
                                                    label="درباره‌ی من"
                                                    name="bio"
                                                    v-model="extras.bio"
                                                    type="text"
                                                    maxlength="2048"
                                            ></v-textarea>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout>
                                        <v-btn
                                                :loading="loading"
                                                :disabled="loading"
                                                color="green"
                                                class="white--text"
                                                large
                                                block
                                                type="submit"
                                        >
                                            ذخیره
                                            &nbsp;
                                            <v-icon left dark>save</v-icon>
                                        </v-btn>
                                    </v-layout>

                                    <v-layout>
                                        <v-flex>
                                            <image-select
                                                    label="نگاره‌ی کاربری"
                                                    :max-size="512"
                                                    :size-forced="false"
                                                    :width="150"
                                                    :height="150"
                                                    format="png,jpg"
                                                    :default-src="typeof user_data.avatar !== 'undefined' && user_data.avatar.length === 0?'':'/reseller_privates/avatars/'+user_data.avatar"
                                                    v-model="avatar"
                                            ></image-select>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <image-select
                                                    label="نگاره‌ی دیوار پروفایل"
                                                    :max-size="1024"
                                                    :size-forced="false"
                                                    :width="1200"
                                                    :height="550"
                                                    format="png,jpg"
                                                    v-model="wall"
                                                    :default-src="typeof extras.wall !== 'undefined' && extras.wall.length === 0?'':'/reseller_privates/avatars/'+extras.wall"
                                            ></image-select>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </div>
                        </v-widget>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-container>
        <v-snackbar
                :timeout="snackbar.timeout"
                :color="snackbar.color"
                :top="snackbar.y === 'top'"
                :bottom="snackbar.y === 'bottom'"
                :right="snackbar.x === 'right'"
                :left="snackbar.x === 'left'"
                :multi-line="snackbar.mode === 'multi-line'"
                :vertical="snackbar.mode === 'vertical'"
                v-model="snackbar.snackbar"
        >
            {{ snackbar.text }}
            <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';
import ImageSelect from '../../components/ImageSelect';

export default {
  components: {
    ImageSelect,
    VWidget
  },
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      sexes: [
        {
          id: 'Male',
          name: 'مرد',
        },
        {
          id: 'Female',
          name: 'زن',
        }
      ],
      person_types: [
        {
          id: 'Individual',
          name: 'حقیقی',
        },
        {
          id: 'Legal',
          name: 'حقوقی',
        }
      ],
      user_data: {
        'res_id': 0,
        'special': false,
        'sex': 'Male',
        'name': '',
        'city': 0,
        'phone': '',
        'email': '',
        'family': '',
        'showing_name': '',
        'mobile': '',
        'address': '',
        'national': '',
        'password': '',
        'created_at': '0001-01-01T00:00:00Z',
        'person_type': 'Individual',
        'postal_code': '',
        'accepted_at': '0001-01-01T00:00:00Z',
        'connector_name': '',
        'connector_post': '',
        'sales_reference': '',
        'shaba': 'IR',
        'accepted_admin': 0,
        'balance': 0,
        'debt_limit': 0
      },
      extras: {
        bio: '',
        wall: '',
        dribble: '',
        youtube: '',
        twitter: '',
        telegram: '',
        facebook: '',
        instagram: '',
      },
      wall: null,
      avatar: null,
      services: [],
      admins: [],
      resellers: [],
      provinces: [],
      cities: [],
      province_id: 0,
      loader: null,
      loading: false,
      rules: {
        required: (value) => !!value || 'پر کردن این فیلد اجباری است.',
      }
    };
  },
  computed: {
    getCities: function () {
      let p = this.province_id;
      if (p === 0) {
        return this.cities;
      }
      return this.cities.filter(c => c.vip_province_id === p);
    }
  },
  watch: {
    loader () {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => {
        this[l] = false;
      }, 1000);
      this.loader = null;
    },
    avatar (avatar) {
      let formData = new FormData();
      formData.append('avatar', avatar);
      this.loader = 'loading';
      this.loading = true;
      this.axios.post('/reseller/profile_setting/images',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(() => {
        this.snackbar.snackbar = true;
        this.snackbar.text = 'با موفقیت ذخیره شد';
        this.snackbar.color = 'green';
      }).catch(e => {
        this.snackbar = HttpErrorToSnackbar(e);
      });
    },
    wall (wall) {
      let formData = new FormData();
      formData.append('wall', wall);
      this.loader = 'loading';
      this.loading = true;
      this.axios.post('/reseller/profile_setting/images',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(() => {
        this.snackbar.snackbar = true;
        this.snackbar.text = 'با موفقیت ذخیره شد';
        this.snackbar.color = 'green';
      }).catch(e => {
        this.snackbar = HttpErrorToSnackbar(e);
      });
    }
  },
  mounted: function () {
    this.axios.get('/reseller/z_city/')
      .then(response => {
        this.cities = response.data.Data;
        this.axios.get('/reseller/z_province/')
          .then(response => {
            this.provinces = response.data.Data;
            this.axios.get('/reseller/who_am_i')
              .then(response => {
                this.user_data = response.data;
                if (response.data.extras !== null) {
                  this.extras = response.data.extras;
                  console.log(this.extras);
                }
                // eslint-disable-next-line max-nested-callbacks
                let p = this.cities.find(c => c.id === this.user_data.city);
                if (typeof p !== 'undefined') {
                  this.province_id = p.vip_province_id;
                }
              })
              .catch(error => {
                this.snackbar = HttpErrorToSnackbar(error);
              });
          })
          .catch(error => {
            this.snackbar = HttpErrorToSnackbar(error);
          });

      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });

  },
  methods: {
    fixTelegram () {
      this.extras.telegram = this.extras.telegram.replace('@', 'https://t.me/');
      if (this.extras.telegram.indexOf('http') === -1) {
        this.extras.telegram = 'https://t.me/' + this.extras.telegram;
      }
    },
    handleSubmit () {
      this.$validator.validateAll().then((isValidate) => {
        if (isValidate) {
          this.loader = 'loading';
          this.axios.post('/reseller/profile_setting', this.user_data)
            .then(() => {
              // Response Submit Method
              this.snackbar.text = 'با موفقیت انجام شد.';
              this.snackbar.y = 'bottom';
              this.snackbar.color = 'success';
              this.snackbar.snackbar = true;
              this.loading = false;
            })
            .catch(error => {
              this.snackbar = HttpErrorToSnackbar(error);
              this.loading = false;
            });
        }
      });
    },
    handleSubmitExtra () {
      this.$validator.validateAll().then((isValidate) => {
        if (isValidate) {
          this.loader = 'loading';
          this.axios.post('/reseller/profile_setting/extra', this.extras)
            .then(() => {
              // Response Submit Method
              this.snackbar.text = 'با موفقیت انجام شد.';
              this.snackbar.y = 'bottom';
              this.snackbar.color = 'success';
              this.snackbar.snackbar = true;
              this.loading = false;
            })
            .catch(error => {
              this.snackbar = HttpErrorToSnackbar(error);
              this.loading = false;
            });
        }
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/profile_setting/setting.vue